import styled, { css } from 'styled-components';
import { TextInput } from '@prisjakt/ui-inputs';
import { layout, media } from '@prisjakt/ui-base';
import * as UiButton from '@prisjakt/ui-button';
import CheckCircleIcon from 'mdi-react/CheckCircleIcon';
import { Variant } from './types';

export const Legal = styled.div`
  font-size: ${layout.measurements.fontSizeSmall};
  margin-top: ${layout.spacing.xSmall};
  text-decoration: underline;

  ${media.smallOnly`
    font-size: ${layout.measurements.fontSizeSmall};
    text-align: center;
  `}
`;

export const Feedback = styled.div`
  font-size: ${layout.measurements.fontSizeSmall};
`;

export const Title = styled.div`
  font-size: ${layout.measurements.fontSizeMedium};
  font-weight: 600;
  margin-bottom: ${layout.spacing.small};
`;

export const SubscribeTitle = styled.b`
  margin-left: ${layout.spacing.xSmall};
`;
export const SubscribeSubTitle = styled.div`
  margin-bottom: ${layout.spacing.xSmall};
  margin-top: ${layout.spacing.xSmall};
`;

export const SubscribedCheckIcon = styled(CheckCircleIcon).attrs(() => ({
  size: '16px',
}))`
  border-radius: 16px;
  background-color: white;
  fill: ${p => p.theme.colors.positive500};
  vertical-align: middle;
`;

export const Form = styled.form`
  margin-bottom: ${layout.spacing.xSmall};
`;

type InlineInputProps = { stacked?: boolean };
export const InlineInput = styled(TextInput)<InlineInputProps>`
  flex-grow: 1;

  ${p =>
    !p.stacked &&
    css`
      margin-right: 20px;
      margin-top: 2px;
    `}
`;

export const Flex = styled.div`
  display: flex;
  align-items: top;
  flex-direction: 'row';
  background-color: 'red';
`;

export const Text = styled.div`
  margin-bottom: ${layout.spacing.small};
`;

export const Button = styled(UiButton.default)`
  margin-left: ${layout.spacing.xSmall};
  height: min-content;
`;

type NewsLetterProps = { variant: Variant } & { stacked: boolean };
export const NewsLetter = styled.div<NewsLetterProps>`
  margin: ${layout.spacing.xSmall};
  color: ${p => p.variant === 'secondary' && p.theme.colors.base600};
  ${Title} {
    color: ${p => p.variant === 'secondary' && p.theme.colors.base700};
  }
  ${Legal} a {
    color: ${p =>
      p.variant === 'primary'
        ? p.theme.colors.base600
        : p.theme.colors.base600};

    :hover {
      color: ${p =>
        p.variant === 'primary'
          ? p.theme.colors.base600
          : p.theme.text.callToActionHover};
    }
  }
  ${Feedback} {
    color: ${p =>
      p.variant === 'primary'
        ? p.theme.colors.negative700
        : p.theme.colors.base600};
  }
  ${Flex} {
    flex-direction: ${p => (p.stacked ? 'column' : 'row')};
  }
  ${Button} {
    ${p =>
      p.stacked &&
      `margin-left: 0;
    margin-top: ${layout.spacing.xSmall};`}
  }
`;
